import type { InputProps as AntdInputProps } from 'antd';
import type { FieldValues, Path } from 'react-hook-form';

import type { ReactNode } from 'react';
import React from 'react';

import { Input as InputAntd } from 'antd';

type TextAreaProps<TFieldValues extends FieldValues> = AntdInputProps & {
  id?: string;
  placeholder?: string;
  className?: string;
  addonBefore?: ReactNode;
  maxLength?: number;
  name?: Path<TFieldValues>;
  onChange?: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

const TextArea = <TFieldValues extends FieldValues>(
  props: TextAreaProps<TFieldValues>
) => {
  const {
    onChange,
    name,
    className,
    placeholder,
    id,
    disabled,
    defaultValue,
    showCount
  } = props;

  if (!name || !onChange) {
    return null;
  }

  return (
    <InputAntd.TextArea
      autoSize={{ minRows: 4, maxRows: 6 }}
      rows={4}
      showCount={showCount}
      placeholder={placeholder}
      className={className}
      id={id}
      onChange={onChange}
      name={name}
      defaultValue={defaultValue}
      disabled={disabled}
    />
  );
};

export { TextArea };
export type { TextAreaProps };
